module.exports = __webpack_public_path__ + "media/37.d13a6b05.mp3";